<template>
    <div class="first">
        <h3>{{ $t('offer.other_section_title') }}</h3>
        <div class="form-floating mb-2">
            <input v-model="offer.user_provided_id" type="text" class="form-control" id="floatingNazov"
                :placeholder="$t('offer.other_id_ph')" />
            <label for="floatingNazov">{{ $t('offer.other_id_label') }}</label>
        </div>
        <div v-show="mojefirmy" class="combobox_mojefirmy">
            <v-combobox v-show="mojefirmy.length > 0" v-model="offer.mojafirma_nazov" label="Moja firma*"
                :items="searchMojeFirmy" filled @blur="handleBlur">
                <template v-slot:item="{ item, on, attrs }">
                    <v-list-item v-bind="attrs" v-on="on" @click="onFirmaSelected(item)">
                        <v-list-item-content>
                            <v-list-item-title>{{ item }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </template>
            </v-combobox>
        </div>
        <div v-show="mojefirmy.length == 0" class="form-floating">
            <input type="text" class="form-control" id="floatingNazov" @focus="mojafirma_showerror = true"
                @blur="mojafirma_showerror = false" placeholder="Moja firma" />
            <label for="floatingNazov">Moja firma</label>
            <div class="klient_sim" v-show="mojafirma_showerror">
                <div class="nothing">
                    <div class="top">{{ $t('offer.other_no_firms') }}</div>
                </div>
            </div>
        </div>
        <p class="mas_viac_firiem">
            {{ $t('offer.other_more_firms') }}
            <a v-if="is_paid" target="_blank" href="/admin/nastavenia/firmy">Pridaj si ich</a>
            <span v-else @click="openModal = true">Pridaj si ich</span>
            <paid-modal-icon v-if="!is_paid" :openModal="openModal" @close="openModal = false"/>
        </p>
        <div id="floatContainer" class="float-container dateInput" style="margin-top: 10px">
            <label class="floatField_dateInput" for="floatField_dateInput">{{ $t('offer.other_issue_date') }}</label>
            <date-picker :shortcuts="this.shortcuts_back" type="date" v-model="offer.datum_vystavenia" :lang="locale" 
                format="DD.MM.YYYY" placeholder="dd.mm.rrrr" valueType="format"
                @focusin="$emit('datum_vystavenia', true)" @focusout="$emit('datum_vystavenia', false)">
            </date-picker>
        </div>
        <div id="floatContainer" class="float-container dateInput" style="margin-top: 10px">
            <label class="floatField_dateInput" for="floatField_dateInput">{{ $t('offer.other_valid_date') }}</label>
            <date-picker :shortcuts="this.shortcuts" type="date" v-model="offer.platnost" :lang="locale"
                :disabled-date="notBeforeToday" format="DD.MM.YYYY" placeholder="dd.mm.rrrr" valueType="format"
                @focusin="$emit('platnost', true)" @focusout="$emit('platnost', false)">
            </date-picker>
        </div>
        <label class="jazyk">Jazyk ponuky</label>
        <div v-if="premium.id" class="jazyky">
            <div class="check">
                <label class="check_container">
                    <input type="radio" name="lang" @click="offer.lang = 'sk'"
                        :checked="offer.lang == 'sk' ? 'checked' : ''" />
                    <span class="check_checkmark"></span>
                </label>
                <span class="check_txt" style="cursor: pointer" @click="offer.lang = 'sk'">
                    {{ $t('offer.other_lang_sk') }}
                </span>
            </div>
            <div class="check">
                <label class="check_container">
                    <input type="radio" name="lang" @click="offer.lang = 'cz'"
                        :checked="offer.lang == 'cz' ? 'checked' : ''" />
                    <span class="check_checkmark"></span>
                </label>
                <span class="check_txt" style="cursor: pointer" @click="offer.lang = 'cz'">
                    {{ $t('offer.other_lang_cz') }}
                </span>
            </div>
            <div class="check">
                <label class="check_container">
                    <input type="radio" name="lang" @click="offer.lang = 'en'"
                        :checked="offer.lang == 'en' ? 'checked' : ''" />
                    <span class="check_checkmark"></span>
                </label>
                <span class="check_txt" style="cursor: pointer" @click="offer.lang = 'en'">
                    {{ $t('offer.other_lang_en') }}
                </span>
            </div>
            <div class="check">
                <label class="check_container">
                    <input type="radio" name="lang" @click="offer.lang = 'de'"
                        :checked="offer.lang == 'de' ? 'checked' : ''" />
                    <span class="check_checkmark"></span>
                </label>
                <span class="check_txt" style="cursor: pointer" @click="offer.lang = 'de'">
                    {{ $t('offer.other_lang_de') }}
                </span>
            </div>
            <!-- <div class="check" style="">
                    <label class="check_container" style="cursor:no-drop; opacity: 0.3" >
                        <input type="radio" name="lang" disabled>
                        <span class="check_checkmark"></span>
                    </label>
                    <span class="check_txt" style="cursor:no-drop; opacity: 0.3" >
                        Jazyk
                    </span>
                    <div class="tooltip_jazyk"> 
                        Pripravujeme  
                    </div>
                </div> -->
        </div>
        <div v-if="!premium.id" class="noPremium" style="margin-top: 45px">
            <div class="ColorBox" style="top: -43px">
                <svg width="21" height="14" viewBox="0 0 21 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M2.21746 1.0767L6.181 4.0062L9.71225 0.353954C9.81113 0.251851 9.93616 0.169801 10.078 0.113916C10.2199 0.0580307 10.3749 0.0297499 10.5316 0.0311796C10.6883 0.0326092 10.8426 0.0637127 10.983 0.122173C11.1234 0.180634 11.2462 0.264945 11.3425 0.368829L14.7123 4.00533L18.8039 1.03383C18.9646 0.917375 19.1638 0.844926 19.3748 0.826176C19.5859 0.807427 19.7987 0.843272 19.9848 0.928915C20.171 1.01456 20.3215 1.14591 20.4163 1.3054C20.5111 1.46488 20.5457 1.64489 20.5154 1.82133L18.9529 10.875H2.08517L0.49871 1.86245C0.467197 1.68504 0.501361 1.50377 0.596575 1.3432C0.691789 1.18264 0.843452 1.05053 1.03102 0.964782C1.21859 0.879031 1.43301 0.843778 1.64522 0.863798C1.85744 0.883817 2.0572 0.958142 2.21746 1.0767ZM2.16642 11.75H18.8331V12.625C18.8331 12.857 18.7233 13.0796 18.528 13.2437C18.3326 13.4078 18.0677 13.5 17.7914 13.5H3.20809C2.93182 13.5 2.66687 13.4078 2.47152 13.2437C2.27617 13.0796 2.16642 12.857 2.16642 12.625V11.75Z"
                        fill="#FBBF24" />
                </svg>
                <div>
                    {{ $t('offer.other_en_upsell') }}
                    <a href="/admin/balicky">Prejdi na PREMIUM.</a>
                </div>
            </div>
        </div>

        <currency-offer v-bind:offer_uuid="uuidOffer" v-bind:currency_data="currency_data" />
    </div>
</template>

<script>
import { EventBus } from './EventBus';
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

import CurrencyOffer from "./CurrencyOffer.vue";
import PaidModalIcon from "../../vue_components/PaidModalIcon.vue";
export default {
    props: [
        "offer",
        "mojefirmy",
        "searchMojeFirmy",
        "premium",
        "uuidOffer",
        "currency_data",
    ],
    components: {
        DatePicker,
        CurrencyOffer,
        PaidModalIcon,
    },
    data() {
        return {
            mojafirma_showerror: false,
            openModal: false,
            shortcuts: [
                { text: 'Dnes', onClick: () => new Date() },                             // Today
                { text: 'Včera', onClick: () => new Date(new Date().setDate(new Date().getDate() - 1)) },  // Yesterday
                { text: 'Zajtra', onClick: () => new Date(new Date().setDate(new Date().getDate() + 1)) }, // Tomorrow
                { text: 'O týždeň', onClick: () => new Date(new Date().setDate(new Date().getDate() + 7)) }, // Next Week
                { text: 'O mesiac', onClick: () => new Date(new Date().setMonth(new Date().getMonth() + 1)) }, // Next Month
                { text: 'O rok', onClick: () => new Date(new Date().setFullYear(new Date().getFullYear() + 1)) }, // Next Year
                { text: 'O 2 roky', onClick: () => new Date(new Date().setFullYear(new Date().getFullYear() + 2)) }, // Next Year
            ],
            shortcuts_back: [
                { text: 'Dnes', onClick: () => new Date() },                             // Today
                { text: 'Včera', onClick: () => new Date(new Date().setDate(new Date().getDate() - 1)) },  // Yesterday
                { text: 'Pred týždňom', onClick: () => new Date(new Date().setDate(new Date().getDate() - 7)) }, // Tomorrow
                { text: 'Pred mesiacom', onClick: () => new Date(new Date().setMonth(new Date().getMonth() - 1)) }, // Next Week
                { text: 'Pred rokom', onClick: () => new Date(new Date().setFullYear(new Date().getFullYear() - 1)) }, // Next Month
                { text: 'Pred 2 rokmi', onClick: () => new Date(new Date().setFullYear(new Date().getFullYear() - 2)) }, // Next Year
            ],
            locale: {
                formatLocale: {
                    months: this.$t('offer.datepicker_months').split(','),
                    monthsShort: this.$t('offer.datepicker_months_short').split(','),
                    weekdays: this.$t('offer.datepicker_weekdays').split(','),
                    weekdaysShort: this.$t('offer.datepicker_weekdays_short').split(','),
                    weekdaysMin: this.$t('offer.datepicker_weekdays_short').split(','),
                    firstDayOfWeek: 1,
                }
            },
            lastValidValue: null,
            is_paid: false
        }
    },
    mounted(){
        EventBus.$on('is_paid', (val) => {
            this.is_paid = val;
        });
    },
    methods: {
        notBeforeToday(date) {
            return date < new Date(new Date().setHours(0, 0, 0, 0));
        },
        handleBlur() {
            if (!this.searchMojeFirmy.includes(this.offer.mojafirma_nazov)) {
                this.offer.mojafirma_nazov = this.lastValidValue;
            }
        },
        // Klik na firmu v selecte (aj na uz vybratu) vzdy prepise vsetky firemne udaje
        onFirmaSelected(nazov) {
            const firma = this.mojefirmy.find((item) => item.nazov == nazov);
            if (!firma) return;
            this.offer.mojafirma_nazov = nazov;
            this.offer.mojafirma = firma;
            EventBus.$emit('mojafirma_selected', firma);
            EventBus.$emit('mojafirma_dph', firma.dph);
        },
    },
    watch: {
        'offer.mojafirma_nazov': {
            handler(newVal) {
                if (this.searchMojeFirmy.includes(newVal)) {
                    this.lastValidValue = newVal;
                }
                if (this.is_paid == 0) {
                    this.offer.mojafirma = this.mojefirmy[0];
                    EventBus.$emit('mojafirma_dph', this.mojefirmy[0].dph);
                    return;
                }
                const moja_firma = this.mojefirmy.find(item => item.nazov == newVal);
                EventBus.$emit('mojafirma_dph', moja_firma.dph);
            }
        },
    },
};
</script>
<style lang="scss">
.dateInput {
    display: grid;

    input.mx-input {
        border: none !important;
        border: none;
        box-shadow: none !important;
        color: #000;
        font-size: 16px;
        line-height: 20px;
        outline: 0;
        padding: 15px !important;
        padding: 0 0 0 17px;
        width: 100%;
    }
}

.dateInput .mx-input {
    box-shadow: none !important;
    -webkit-box-shadow: none !important;
}

.dateInput .mx-datepicker {
    width: 100% !important;
}

.dateInput path {
    fill: #383c4c !important;
}

.floatField_dateInput {
    color: #9598a7;
    font-family: Roboto;
    font-size: 11px;
    font-style: normal;
    font-weight: 700;
    letter-spacing: .1em;
    line-height: 13px;
    margin-top: 0;
    margin-bottom: 0;
    text-transform: uppercase;
    padding: 10px 0 0 17px;
}
</style>
<style lang="scss" scoped>
.mas_viac_firiem {
    display: flex;
    align-items: center;
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    color: #9598a7;
    padding: 5px 0;
    margin-bottom: 0;
    gap: 4px;

    a,span {
        cursor: pointer;
        color: #212541;
        text-decoration: none;

        &:hover {
            color: #212541;
            font-weight: bold;
        }
    }
}

.form-floating {
    margin-top: 20px;
}

h3 {
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    line-height: 21px;
    color: #212541;
}

p {
    margin-top: 7px;

    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;

    color: #9598a7;
}

.form-floating>label {
    padding: 22px 13px;

    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 11px;
    line-height: 13px;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: #9598a7;
}

input {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;

    color: #212541;

    border: 1px solid #dde3e8;
    border-radius: 0;
}

label {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    color: #212541;
}

input[type="checkbox"] {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    -webkit-tap-highlight-color: transparent;
    cursor: pointer;
    margin: 0px 10px 0 0px;
    background: #c7d4eb;
    border-radius: 25px;
}

.toggle label {
    @media (max-width: 600px) {
        width: 70%;
    }
}

.toggle {
    height: 22px;
    width: 40px;
    display: inline-block;
    position: relative;
    margin: 0;
    border: none;
    background: #ffffff;
    border-radius: 3px;
    transition: all 0.2s ease;

    &:focus {
        outline: 0;
    }

    &:after {
        content: "";
        position: absolute;
        top: 4px;
        left: 3px;
        width: 14px;
        height: 14px;
        border-radius: 50%;
        background: white;
        box-shadow: 0 1px 2px rgba(44, 44, 44, 0.2);
        transition: all 0.2s cubic-bezier(0.5, 0.1, 0.75, 1.35);
    }

    &:checked {
        border-color: #2ed8b6;
        background: #2ed8b6;
    }

    &:checked:after {
        transform: translatex(20px);
    }
}

.mobile_doba_inputs {
    display: grid !important;
}

.doba_inputs {
    background: white;
    padding: 20px;
    width: 100%;

    @media (max-width: 550px) {
        margin: 20px 0 !important;
    }

    .form-floating>label,
    .float-container label {
        font-family: Roboto;
        font-style: normal;
        font-weight: bold;
        font-size: 11px;
        line-height: 13px;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        color: #9598a7;
    }

    input {
        height: 50px;
        border-radius: 0;
    }

    textarea {
        border-radius: 0;
    }
}

.info {
    position: relative;
    height: 20px;
    margin-left: 10px;

    .info_icon {
        pointer-events: all;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 20px;
        height: 20px;
        float: right;

        img {
            width: 80%;
            height: 80%;
        }
    }

    .my_tooltip {
        bottom: 22px;
        right: -7px;
    }
}

.agree_tooltip {
    position: relative;
}

.my_tooltip {
    pointer-events: none;
    opacity: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 300px;
    background: #f3385a;
    box-shadow: 0px 2px 2px rgba(143, 153, 179, 0.2);
    border-radius: 6px;
    font-weight: 800;
    font-size: 14px;
    line-height: 18px;
    color: #fff;
    padding: 10px;
    position: absolute;
    top: unset;
    right: 15px;
    z-index: 10000;
    transition: opacity 0.5s ease-in-out;

    &::after {
        content: "";
        width: 15px;
        height: 15px;
        background: #f3385a;
        position: absolute;
        right: 10px;
        bottom: -3px;
        transform: rotate(45deg);
        border-radius: 3px;
    }
}

.sup {
    color: #f83d34;
    font-size: 13px;
}

.jazyky {
    display: flex;
    width: 90%;
    gap: 30px;
    align-items: center;

    @media (max-width: 600px) {
        flex-direction: column;
        align-items: flex-start;
        gap: 5px;
    }
}

.noPremium {
    position: relative;
}

textarea.klient_udaje_top {
    padding-top: 3px !important;

    @media screen and (max-width: 1450px) {
        padding-top: 15px !important;
    }
}

.jazyk {
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 11px;
    line-height: 13px;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: #9598a7;
    padding: 20px 0 0 0;
    margin-bottom: 0;
}

.check {
    position: relative;
    width: fit-content;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 16px;
    margin-top: 15px;

    span.check_txt {
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 16px;
        color: #212541;
    }

    &:hover {
        .tooltip_jazyk {
            opacity: 1 !important;
        }
    }

    .tooltip_jazyk {
        pointer-events: none;
        opacity: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 125px;
        background: #f3385a;
        box-shadow: 0px 2px 2px rgb(143 153 179 / 20%);
        border-radius: 6px;
        font-weight: 800;
        font-size: 14px;
        line-height: 18px;
        color: #fff;
        padding: 10px;
        position: absolute;
        top: -50px;
        right: -1px;
        z-index: 10000;
        transition: opacity 0.5s ease-in-out;

        &::after {
            content: "";
            width: 15px;
            height: 15px;
            background: #f3385a;
            position: absolute;
            right: 10px;
            bottom: -3px;
            transform: rotate(45deg);
            border-radius: 3px;
        }
    }

    .check_container {
        position: relative;
        cursor: pointer;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        width: 16px;
        height: 16px;
        margin-right: 5px;
        margin-bottom: 5px;
    }

    .check_container input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;
    }

    .check_checkmark {
        position: absolute;
        top: 0;
        left: 0;
        height: 16px;
        width: 16px;
        background-color: #ffffff;
        border: 1px solid #212541;
        border-radius: 3px;
    }

    .check_container:hover input~.check_checkmark {
        background-color: #ffffff;
    }

    .check_container input:checked~.check_checkmark {
        background-color: #212541;
    }

    .check_checkmark:after {
        content: "";
        position: absolute;
        display: none;
    }

    .check_container input:checked~.check_checkmark:after {
        display: block;
    }

    .check_container .check_checkmark:after {
        left: 5px;
        top: 1px;
        width: 5px;
        height: 10px;
        border: 1px solid #fff;
        border-width: 0 2px 2px 0;
        transform: rotate(45deg);
    }
}

.info {
    position: relative;
    height: 20px;
    margin-left: 10px;

    .info_icon {
        pointer-events: all;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 20px;
        height: 20px;
        float: right;

        img {
            width: 80%;
            height: 80%;
        }
    }

    .my_tooltip {
        bottom: 22px;
        right: -7px;
    }
}

.agree_tooltip {
    position: relative;
}

.my_tooltip {
    pointer-events: none;
    opacity: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 300px;
    background: #f3385a;
    box-shadow: 0px 2px 2px rgba(143, 153, 179, 0.2);
    border-radius: 6px;
    font-weight: 800;
    font-size: 14px;
    line-height: 18px;
    color: #fff;
    padding: 10px;
    position: absolute;
    top: unset;
    right: 15px;
    z-index: 10000;
    transition: opacity 0.5s ease-in-out;

    &::after {
        content: "";
        width: 15px;
        height: 15px;
        background: #f3385a;
        position: absolute;
        right: 10px;
        bottom: -3px;
        transform: rotate(45deg);
        border-radius: 3px;
    }
}

.klient_sim {
    display: grid;
    position: absolute;
    top: 58px;
    left: 0;
    width: auto;
    height: auto;
    background: #ffffff;
    border: 1px solid #dde3e8;
    border-top: 0;
    box-sizing: border-box;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
    z-index: 1000;
    pointer-events: all;

    span {
        font-family: Roboto;
        font-style: normal;
        font-weight: 500;
        font-size: 13px;
        line-height: 15px;
        color: #212541;
        padding: 13px;
        cursor: pointer;

        &:hover {
            color: #2ed8b6;
        }
    }

    .nothing {
        .top {
            font-family: Roboto;
            font-style: italic;
            font-weight: normal;
            font-size: 13px;
            line-height: 15px;
            color: #000000;
            padding: 22px;
        }
    }

    .bottom {
        font-family: Roboto;
        font-style: normal;
        font-weight: bold;
        font-size: 14px;
        line-height: 16px;
        padding: 22px;
        color: #2ed8b6;
        cursor: pointer;
        border-top: 1px solid #9598a7;
    }
}

.form-floating {
    position: relative;

    .lupa {
        position: absolute;
        right: 6px;
        top: 0;
        bottom: 0;
        margin: auto;
    }
}

.last_klients {
    width: 100%;
    display: flex;
    margin-top: 10px;

    span {
        width: auto;
        height: auto;

        background: #f2f7fb;
        border-radius: 4px;
        transition: 0.5s ease-in-out all;

        padding: 12px;
        margin-right: 6px;

        display: flex;
        align-items: center;
        justify-content: center;

        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 13px;
        line-height: 15px;
        text-align: center;
        color: #212541;

        cursor: pointer;

        &:hover {
            background: #dcecfa;
        }
    }
}

.error {
    border: 1px solid #dc3545 !important;
}

.one_cont {
    width: 560px;

    @media (max-width: 600px) {
        width: 95%;
    }

    h1 {
        font-style: normal;
        font-weight: 500;
        font-size: 36px;
        line-height: 45px;
        color: #212541;
    }

    textarea,
    input {
        font-family: Roboto;
        font-style: normal;
        font-weight: bold;
        font-size: 14px;
        line-height: 16px;
        display: flex;
        align-items: center;

        color: #212541;

        border: 1px solid #dde3e8;
        border-radius: 0;
    }

    .ulozitbtn {
        width: 100%;
        display: flex;
        justify-content: flex-end;

        .ulozit {
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;

            width: 103px;
            height: 55px;
            border: 1px solid #2ed8b6;
            box-sizing: border-box;
            border-radius: 4px;
            font-family: Roboto;
            font-style: normal;
            font-weight: bold;
            font-size: 16px;
            line-height: 19px;
            text-align: center;
            color: #2ed8b6;
        }

        .pokracovat {
            margin-left: 20px;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: space-around;

            width: 200px;
            height: 55px;
            background: #2ed8b6;
            box-sizing: border-box;
            border-radius: 4px;
            font-family: Roboto;
            font-style: normal;
            font-weight: 800;
            font-size: 17px;
            line-height: 182.5%;
            text-align: center;
            color: #ffffff;
            transition: 0.5s ease-in-out all;

            img {
                transition: 0.5s ease-in-out all;
                transform: translateX(0px);
            }

            &:hover {
                img {
                    transform: translateX(15px);
                }
            }
        }
    }

    .float-container {
        border: 1px solid #dde3e8;
        border-radius: 0;
        margin-top: 20px;
    }

    .form-floating {
        margin-top: 20px;
    }

    .form-floating>label {
        padding: 22px 13px;
    }

    .form-floating>label,
    .float-container label {
        font-family: Roboto;
        font-style: normal;
        font-weight: bold;
        font-size: 11px;
        line-height: 13px;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        color: #9598a7;
        margin-top: 0;
    }

    .first {
        width: 100%;
        padding: 20px;
        background: #ffffff;
        box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.05);
        border-radius: 4px;

        margin-top: 20px;

        .textarea {
            border: 1px solid #dde3e8;
            border-radius: 0;

            textarea {
                border: none !important;
                border-top: 25px solid transparent !important;
                padding-top: 0;
                width: 100%;
                height: 120px;
                background: #ffffff;
                box-sizing: border-box;
            }
        }
    }
}
</style>
